import { atomWithQuery } from 'jotai-tanstack-query'
import AuthService from '@app/services/authService'
import { clientNameAtom } from '@app/state/clientsAtom'
import { AxiosError } from 'axios'
import { atom } from 'jotai'
import type { UserProfile, UserRole } from '@app/types'
import { USERS_QUERY_KEY } from '@app/modules/Admin/utils/Admin.constants'

const nullUser: UserProfile = {
  user_roles: [],
  user_uuid: '',
  client_name: '',
  accepted_tsncs: false,
  email: '',
  date_created: null,
  status: 'UNCONFIRMED',
  last_logged_in: '',
  logged_in_count: '',
  show_changelog: false,
}

export const canExportAtom = atom((get) => {
  const user = get(userAtom)
  return user.data?.user_roles.includes('member' as UserRole) ?? false
})

export const isStaffAtom = atom((get) => {
  const user = get(userAtom)
  return user.data?.user_roles.includes('staff' as UserRole) ?? false
})

export const userAtom = atomWithQuery<UserProfile>((get) => {
  const clientName = get(clientNameAtom) ?? ''
  return {
    queryKey: [USERS_QUERY_KEY, clientName],
    queryFn: async () => {
      try {
        const response = await AuthService.user()
        if (!response) {
          return { ...nullUser, client_name: clientName }
        }

        return response as UserProfile
      } catch (error) {
        if (error instanceof AxiosError) {
          if (error.response?.status == 401) return { ...nullUser, client_name: clientName }
        }
        throw error
      }
    },
    enabled: !!clientName,
  }
})

userAtom.debugLabel = 'userAtom'
canExportAtom.debugLabel = 'canExportAtom'
isStaffAtom.debugLabel = 'isStaffAtom'
